import {
  getIsPreOrder,
  getPurchaseStatus
} from '@/srp/SearchResults/ResultTile/helpers/ResultTile.helpers';
import { Tag } from '@/srp/SearchResults/ResultTile/Tags/constants';
import TagId from '~/constants/srp/TagId';
import { useTileDataContext } from '~/context/srp/TileDataContext';

export default function useGetStatusTag() {
  const { tileData } = useTileDataContext();
  const showPreOrderTag = getIsPreOrder(tileData);
  const { isLocked: showLockedTag, isOnHold: showOnHoldTag } =
    getPurchaseStatus(tileData);
  const { vehicleTags = [] } = tileData;
  const showRecentlyAdded = vehicleTags.some(
    tag => tag.tagId === TagId.RecentlyAdded
  );

  switch (true) {
    case showOnHoldTag:
      return Tag.Hold;
    case showPreOrderTag:
      return Tag.Reservable;
    case showLockedTag:
      return Tag.Locked;
    case showRecentlyAdded:
      return Tag.Recent;
    default:
      return null;
  }
}
